export default __webpack_public_path__ + "static/media/INDO.f0916df9.webp";